import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Suspense, lazy } from 'react';

import ScrollToTop from './components/ScrollToTop/ScrollToTop';

const BUILD_TARGET = process.env.REACT_APP_BUILD_TARGET;
const IS_MAIN = BUILD_TARGET !== 'admin';
const IS_ADMIN = BUILD_TARGET === 'admin';

// Lazy load: main (public) pages – only loaded when BUILD_TARGET is main
const Home = lazy(() => import('./pages/Home/Home'));
const About = lazy(() => import('./pages/About/About'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const Event = lazy(() => import('./pages/Event/Event'));
const Gallery = lazy(() => import('./pages/Gallery/Gallery'));
const Menu = lazy(() => import('./pages/Menu/Menu'));
const Reservation = lazy(() => import('./pages/ReserveTable/Reservation'));
const VipReservation = lazy(() => import('./pages/VipReservation/VipReservation'));

// Lazy load: admin pages – only loaded when BUILD_TARGET is admin
const AdminDashboard = lazy(() => import('./pages/AdminDashboard/AdminDashboard'));
const Admin = lazy(() => import('./pages/Admin/Admin'));
const ReservationDashboard = lazy(() => import('./pages/ReservationDashboard'));
const VipReservationDashboard = lazy(() => import('./pages/VipReservationDashboard'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <HelmetProvider>
          <Suspense fallback={""}>
            <Routes>
              {IS_MAIN && (
                <>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/events" element={<Event />} />
                  <Route path="/menu" element={<Menu />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/reservation" element={<Reservation />} />
                  <Route path="/vip-reservation" element={<VipReservation />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </>
              )}
              {IS_ADMIN && (
                <>
                  <Route path="/" element={<AdminDashboard />} />
                  <Route path="/admin-dashboard" element={<AdminDashboard />} />
                  <Route path="/elysium-management-panel-2025" element={<Admin />} />
                  <Route path="/reservation-dashboard" element={<ReservationDashboard />} />
                  <Route path="/vip-reservation-dashboard" element={<VipReservationDashboard />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </>
              )}
            </Routes>
          </Suspense>
        </HelmetProvider>
      </div>
    </Router>
  );
}

export default App;
